<template>
  <el-dialog :close-on-click-modal="false" title="开票信息" :visible.sync="isShow" width="600px">
    <el-form ref="form" :model="formData" label-width="120px">
      <el-form-item label="发票类型:"> {{ $config.FapiaoType[formData.fapiaoType] }} </el-form-item>
      <el-form-item label="发票金额:"> {{ formData.totalAmount }} </el-form-item>
      <el-form-item label="发票抬头:"> {{ formData.fapiaoTitle }} </el-form-item>
      <template v-show="formData.buyerCert">
        <el-form-item label="纳税人识别号:"> {{ formData.buyerCert ? formData.buyerCert.taxno : '' }} </el-form-item>
        <!-- <el-form-item label="收票人邮箱:"> {{ formData.buyerCert ? formData.buyerCert.email : '' }} </el-form-item> -->
        <el-form-item label="企业地址:"> {{ formData.buyerCert ? formData.buyerCert.addressline : '' }} </el-form-item>
        <el-form-item label="企业电话:"> {{ formData.buyerCert ? formData.buyerCert.phone : '' }} </el-form-item>
        <el-form-item label="开户银行:"> {{ formData.buyerCert ? formData.buyerCert.bankName : '' }} </el-form-item>
        <el-form-item label="银行账号:"> {{ formData.buyerCert ? formData.buyerCert.bankAccount : '' }} </el-form-item>
      </template>
      <el-form-item label="税率:">
        <el-select v-model="taxRateId" placeholder="请选择">
          <el-option v-for="item in rateList" :key="item.taxRateId" :label="item.taxRate + '%'" :value="item.taxRateId">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button round type="primary" @click="onSubmit()">开 票</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { fapiaoInvoice, taxRateGetDefaultTaxRate, taxRateListAll } from '@/api/finance'
export default {
  data () {
    return {
      isShow: false,
      formData: {
        buyerCert: {}
      },
      taxRateId: '',
      rateList: []
    }
  },
  methods: {
    show (val) {
      this.isShow = true
      console.log(val)
      this.formData = val
      if (val.buyerCert) {
        this.formData.buyerCert.phone = this.$msg.filterBridal(val.buyerCert.phone)
      }
      this.getAllRateList()
    },
    hide () {
      this.isShow = false
    },
    onSubmit () {
      if (this.taxRateId === '') {
        this.$message.warning('税率不能为空')
        return
      }
      fapiaoInvoice({
        fapiaoId: this.formData.fapiaoId,
        taxRateId: this.taxRateId
      })
        .then(res => {
          if (res.data.success) {
            this.$message.success('申请成功')
            this.hide()
            this.$emit('kaipiaoSuccess')
          }
        })
    },
    getAllRateList () {
      taxRateListAll()
        .then(res => {
          if (res.data.success) {
            this.rateList = res.data.data
            this.taxRateId = res.data.data.find(item => {
              return item.isDefault
            }).taxRateId
          }
        })
    }
  }
}
</script>
<style></style>
